// Same as in c#
export enum Origin {
  Global = 0,
  Exhibition = 1,
}
